import React from 'react';
import Label from 'shared/components/Label';
import RadioComponent from 'shared/components/RadioComponent';

const ArraySide = (props) => {
  const {
    parameters,
    name,
    label,
    onChangeParameter,
    inputId,
    groupName,
    value,
  } = props;

  const currentValue = parameters[name];

  return (
    <RadioComponent
      name={name}
      label={label}
      value={currentValue}
      checked={currentValue === value}
      onChange={() => onChangeParameter(name, value)}
      inputId={inputId}
      groupName={groupName}
      parameters={parameters} />
  );
};

ArraySide.defaultProps = {
  name: 'rails_sides',
  groupName: 'parameters',
};

const ArrayRailsSides = (props) => {
  const {
    parameters,
    onChangeParameter,
    groupName,
  } = props;

  return (
    <div className="form-group radio-group">
      <Label label="Add rails to" />
      <ArraySide
        label="the two long sides"
        value="two_long_sides"
        onChangeParameter={onChangeParameter}
        inputId="array-side-long"
        groupName={groupName}
        parameters={parameters} />
      <ArraySide
        label="the two short sides"
        value="two_short_sides"
        onChangeParameter={onChangeParameter}
        inputId="array-side-short"
        groupName={groupName}
        parameters={parameters} />
      <ArraySide
        label="all four sides"
        value="all_four_sides"
        onChangeParameter={onChangeParameter}
        inputId="array-side-all"
        groupName={groupName}
        parameters={parameters} />
      <ArraySide
        label="no rails"
        value="no_sides"
        onChangeParameter={onChangeParameter}
        inputId="array-side-no"
        groupName={groupName}
        parameters={parameters} />
      <div className="error-place" />
    </div>
  );
};

export default ArrayRailsSides;
